import { SidebarHelpCardOptions } from 'src/app/layouts/components/sidebar-help-card';

/**
 * Custom  data definitions
 */
export enum CustomSessionDataFieldType {
	STRING = 1,
	DECIMAL = 2,
	INTEGER = 3,
	STRING_CHOICE = 4,
	DECIMAL_CHOICE = 5,
	INTEGER_CHOICE = 6
}

export enum CustomSessionDataFieldValues {
	STRING = 'String',
	DECIMAL = 'Decimal',
	INTEGER = 'Integer',
	STRING_CHOICE = 'String choice',
	DECIMAL_CHOICE = 'Decimal choice',
	INTEGER_CHOICE = 'Integer choice'
}

export enum SessionHelpBannerType {
	LIST = 'list',
	CREATE = 'edit',
	UPDATE = 'update'
}

/**
 * Custom session data definitions types
 */
export enum CustomSessionDataSelectType {
	SINGLE_SELECT = 1,
	MULTI_SELECT = 2
}

/**
 * Custom session data definition model
 */
export interface CustomSessionDataDefinitionModel {
	id?: number;
	choice_select_type?: CustomSessionDataSelectType;
	predefined_values?: CustomSessionDataPredefinedValue[];
	field_type?: CustomSessionDataFieldType;
	field_label?: string;
}

/**
 * Custom session data predefined values model
 */
export interface CustomSessionDataPredefinedValue {
	id?: number;
	csdd_id?: number;
	value?: string;
	sequence?: number;
}

export const appListHelpCard = (): SidebarHelpCardOptions => {
	return {
		title: 'settings.custom_event_data_definition.help.title',
		description: 'settings.custom_event_data_definition.help.description',
		icon: 'comment',
		class: 'side-help'
	};
};

export const appFormHelpCard = (): SidebarHelpCardOptions => {
	return {
		title: 'settings.custom_event_data_definition.help.title',
		description: 'settings.custom_event_data_definition.help.description',
		icon: 'comment',
		class: 'side-help'
	};
};
